const { $ } = window;
//const $body = $( document.body )

export default {
	init() {

	},
	finalize() {
			let is_typing = false;
			let stop_typing = false;
	
			function type_text(text, index, el) {
				
				if (stop_typing) {
					stop_typing = false;
					return;
				}
	
				if (index === 0) {
					is_typing = true;
				}
	
				let this_el = el;
				if (index < text.length) {
					$(this_el).append(text[index]);
					index++;
					setTimeout(function() {
						type_text(text, index, this_el);
					}, 20);
				} else {
					is_typing = false;
				}
	
			}
	
			const target = document.querySelector('.notification-number-1');
			const options = {
				root: null,
				rootMargin: '0px',
				threshold: 1.0
			};
	
			const callback = (entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						setTimeout(function() {
							$('.notification-number-1').addClass('notification-active');
							$('.health-tracking--text-1 .health-tracking--icon').fadeIn(100);
							$('.health-tracking--text-1 .health-tracking--ntext').fadeIn(100, function() {
								let text = $(this).data('text');
								type_text(text, 0, $('.health-tracking--text-1 .health-tracking--ntext'));
							});
						}, 150)
						// setTimeout(function() {
						// 	$('.health-tracking--text-1 .health-tracking--ntext').fadeIn(100, function() {
						// 		let text = $(this).data('text');
						// 		type_text(text, 0, $('.health-tracking--text-1 .health-tracking--ntext'));
						// 	});
						// }, 300)
						observer.unobserve(target);
					}
				});
			};
	
			const observer = new IntersectionObserver(callback, options);
			observer.observe(target);
	
			$('.notification-number-1, .notification-number-2').on('click', function(e) {
				
				if (window.innerWidth <= 991) {
					if (e.type == 'mouseenter') {
						return;
					}
				}
				if (!$(this).hasClass('notification-active')) {
					
					if (is_typing) {
						stop_typing = true;
					}
	
					$('.health-tracking--ntext').html('');
					let num = $(this).data('num');
					let other;
	
					if (num === 1) {
						other = 2;
					} else if (num === 2) {
						other = 1;
					}
	
					$('.notification-number').removeClass('notification-active');
					$(this).addClass('notification-active');
					$('.health-tracking--text:not(.health-tracking--text-' + num + ')').hide(0, function() {
						$('.health-tracking--icon, .health-tracking--ntext').hide();
						$('.health-tracking--text-' + num).show();
						$('#nimage' + other).fadeOut(0, function() {
							$('#nimage' + num).fadeIn(0);
						})
						setTimeout(function() {
							$('.health-tracking--text-' + num + ' .health-tracking--icon').fadeIn(100);
							$('.health-tracking--text-' + num + ' .health-tracking--ntext').fadeIn(100, function() {
								let text = $(this).data('text');
								type_text(text, 0, $('.health-tracking--text-' + num + ' .health-tracking--ntext'));
							});
						}, 150)
						// setTimeout(function() {
						// 	$('.health-tracking--text-' + num + ' .health-tracking--ntext').fadeIn(100, function() {
						// 		let text = $(this).data('text');
						// 		type_text(text, 0, $('.health-tracking--text-' + num + ' .health-tracking--ntext'));
						// 	});
						// }, 300)
					});
					
				}
			});
	},
};
